import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider, unstable_createMuiStrictModeTheme, responsiveFontSizes } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { I18nextProvider } from 'react-i18next';
import { APP_CUSTOM_THEME } from './shared/theme';
import reportWebVitals from './reportWebVitals';
import './index.css';
import 'animate.css/animate.min.css';
import App from './App';
import { setupI18next } from './shared/i18next';

let theme = unstable_createMuiStrictModeTheme(APP_CUSTOM_THEME);
theme = responsiveFontSizes(theme, { factor: 1.9 });
ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={setupI18next()}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
